document.addEventListener("DOMContentLoaded", function() {
/**** login-popup ****/
// Fancybox.bind('[data-fancybox]', {
//         // Custom options for all galleries
//       });   


});

document.addEventListener("click", function (event) {    
  const altli = event.target.closest(".altli");
  if (!altli) return;
 const swatch = altli.querySelector(".var-swatches");
  const swatchImage = swatch?.getAttribute("data-variant-image");
  if (!swatchImage) return;

  const cardWrapper = altli.closest(".card-wrapper");
  if (!cardWrapper) return;

  const imgElement = cardWrapper.querySelector(".card__media img");
  if (imgElement) {
    imgElement.src = swatchImage;
    imgElement.srcset = `
      ${swatchImage}?width=165 165w,
      ${swatchImage}?width=360 360w,
      ${swatchImage}?width=533 533w,
      ${swatchImage}?width=720 720w,
      ${swatchImage}?width=940 940w,
      ${swatchImage}?width=1066 1066w,
      ${swatchImage} 2000w
    `;

    cardWrapper.querySelectorAll(".altli").forEach((el) => {
      if (!el.classList.contains("default-variant")) {
        el.classList.remove("active-variant");
      }
    });

    altli.classList.add("active-variant");
  }
});


// 

 // document.addEventListener("DOMContentLoaded", function() {
 //    document.querySelectorAll('.galley_anchor').forEach(function(el) {
 //      el.addEventListener('click', function(e) {
 //        e.preventDefault();
 //      });
 //    });
 //  });





// Global Banner
const icons = document.querySelectorAll(".c-message-bar__icon");

if (icons.length > 0) {
  icons.forEach(function (icon) {
    icon.addEventListener("click", function () {
      const banner = this.closest(".global-banner-main");
      if (banner) {
        banner.style.display = "none";
      }
    });
  });
}

// Video Banner
const playpauseButtons = document.querySelectorAll(
  ".video-player-toggleButton"
);

if (playpauseButtons.length > 0) {
  playpauseButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const videoContainer = button.closest(".video-conatiner-bottom");

      if (!videoContainer) return; // Ensure the container exists

      const video = videoContainer.querySelector("video");
      if (!video) return; // Ensure a video element exists

      if (video.paused) {
        video.play();
        button.classList.add("active"); // Add 'active' class
        videoContainer.classList.remove("active-overlay");
      } else {
        video.pause();
        button.classList.remove("active"); // Remove 'active' class
        videoContainer.classList.add("active-overlay");
      }
    });
  });
}


// color click code------
document.querySelectorAll(".product-card-wrapper").forEach(function (card) {
  card.querySelectorAll(".var-swatches").forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      let variantImage = this.getAttribute("data-variant-image");
      let productImage = card.querySelector(".card__media img");
      let productLinks = card.querySelectorAll(".card__content a"); // Get all <a> elements in card__content
      let variantID = this.getAttribute("variant-id");

      if (variantImage && productImage) {
        productImage.src = variantImage;
        productImage.srcset = variantImage;
      }

      // Remove 'active' class from all swatches in this card
      card
        .querySelectorAll(".var-swatches")
        .forEach((s) => s.classList.remove("active"));

      // Add 'active' class to the clicked swatch
      this.classList.add("active");

      // Update the href of the nearest <a> (if there is at least one)
      productLinks.forEach((productLink) => {
        let productHref = productLink.getAttribute("href").split("?")[0];
        let newLink = `${productHref}?variant=${variantID}`;
        productLink.href = newLink;
        console.log("Updated product link:", productLink.href);
      });
    });

    // Trigger a click on the first swatch of the card when the page loads (by default clicked first)
    // if (swatch === card.querySelector(".var-swatches")) {
    //   swatch.click();
    // }
  });
});

//wishlist counter-----
function renderWishlistCounter(swat) {
	var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter"); /* Custom header can be added here.*/
	if (counter_elem) {
		for (var i = 0; i < counter_elem.length; i++) {
			if (swat.renderWishlistCount) {
              
				swat.renderWishlistCount(counter_elem[i], function(count, element) {
					document.querySelector('.swym-wishlist')?.classList.toggle('has-items', count > 0);
				});
			} 
		}
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(renderWishlistCounter);


// menu drawer close button
// document.querySelector(".menu-icon-close").addEventListener("click", function () {
//     document.querySelector(".header__icon[aria-controls='menu-drawer']").click();
// });



  const handleFloatingLabels = () => {
    const fields = document.querySelectorAll(".cf-field");

    fields.forEach(field => {
      // Avoid initializing the same field twice
      if (field.dataset.floatingInit) return;

      const input = field.querySelector("input");
      if (!input) return;

      const updateClass = () => {
        if (document.activeElement === input || input.value.trim() !== "") {
          field.classList.add("cf-active");
        } else {
          field.classList.remove("cf-active");
        }
      };

      input.addEventListener("focus", updateClass);
      input.addEventListener("blur", updateClass);
      input.addEventListener("input", updateClass);

      updateClass();

      field.dataset.floatingInit = "true"; // Mark as initialized
    });
  };

  // MutationObserver to detect when .cf-field is added
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          if (node.matches(".cf-field") || node.querySelector(".cf-field")) {
            handleFloatingLabels();
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also run once in case elements already exist
  document.addEventListener("DOMContentLoaded", handleFloatingLabels);

// 



document.querySelectorAll('.account-box span[data-target]').forEach(span => {
  span.addEventListener('click', function () {
    const accountBox = this.closest('.account-box');
    const targetSelector = this.getAttribute('data-target');
    if (accountBox && targetSelector) {
      accountBox.style.display = 'none';
      const target = document.querySelector(targetSelector);
      if (target) {
        target.style.display = 'block';
      }
    }
  });
});



document.querySelectorAll('.vh-play-pause').forEach((button) => {
  button.addEventListener('click', function () {
    const videoId = this.dataset.videoId;
    const videoType = this.dataset.videoType;
    const isPlaying = this.dataset.playing === 'true';

    const videoWrapper = document.getElementById(videoId);

    if (!videoWrapper) return;

    const actualVideo =
      videoWrapper.tagName === 'VIDEO'
        ? videoWrapper
        : videoWrapper.querySelector('video');

    if (!actualVideo) return;

    // Native Shopify hosted video
    if (videoType === 'native') {

      if (isPlaying) {
        actualVideo.pause();
        this.dataset.playing = 'false';
      } else {
        actualVideo.play();
        this.dataset.playing = 'true';
      }
    }

    this.classList.toggle('is-paused');
  });
});


function syncFakeSwatches() {
  document.querySelectorAll(".aldo-color-swatches__input").forEach(fakeInput => {
    const value = fakeInput.value;
    const fakeLabel = fakeInput.closest(".aldo-color-swatches__item");

    // Find the original input with the same value
    const originalInput = document.querySelector(
      `input[name^="Color-"][value="${CSS.escape(value)}"]`
    );

    if (!originalInput || !fakeLabel) return;

    const originalLabel = document.querySelector(
      `label[for="${originalInput.id}"]`
    );

    // Check how your theme marks unavailable variants
    const isDisabled =
      originalInput.disabled ||
      originalInput.classList.contains("disabled") ||
      originalLabel?.classList.contains("disabled") ||
      originalLabel?.classList.contains("visually-disabled-label");

    fakeLabel.classList.toggle("disabled", isDisabled);
  });
}

// Initial
document.addEventListener("DOMContentLoaded", () => {
  syncFakeSwatches();

  // Fake swatch clicked
  document.querySelectorAll(".aldo-color-swatches__input").forEach(input => {
    input.addEventListener("change", () => {
      // Shopify updates after this, so wait a tick
      setTimeout(syncFakeSwatches, 50);
    });
  });

  // Also resync whenever any variant changes
  document.addEventListener("change", e => {
    if (e.target.matches('input[type="radio"]')) {
      setTimeout(syncFakeSwatches, 50);
    }
  });
});


function updateSwatchImage(swatchWrapper, btn) {
    const card = btn.closest(".product-card-wrapper");
    if (!card) return;

    const variants = JSON.parse(swatchWrapper.dataset.variants);
    const media = JSON.parse(swatchWrapper.dataset.media);

    // Use the variant id already computed by Liquid instead of re-deriving by color
    const variantId = Number(btn.dataset.variantId);
    const variant = variants.find(v => v.id === variantId);

    if (!variant || !variant.featured_media) return;

    const images = card.querySelectorAll(".media img");

    // Primary image
    const firstImage = variant.featured_image.src.startsWith("//")
        ? "https:" + variant.featured_image.src
        : variant.featured_image.src;

    images[0].src = firstImage + "&width=533";
    images[0].srcset = firstImage;

    // Hover image
    const nextMedia = media.find(item => item.position === variant.featured_media.position + 1);

    if (nextMedia && images[1]) {
        const secondImage = nextMedia.src.startsWith("//")
            ? "https:" + nextMedia.src
            : nextMedia.src;

        images[1].src = secondImage + "&width=533";
        images[1].srcset = secondImage;
    }

    // --- Update ALL card links with the selected variant id ---
    const cardLinks = card.querySelectorAll("[data-aldo-plp-card-link]");

    cardLinks.forEach(cardLink => {
        const url = new URL(cardLink.getAttribute("href"), window.location.origin);
        url.search = `?variant=${variant.id}`;
        cardLink.setAttribute("href", url.pathname + url.search);
    });
    // --- End URL update ---
}

// --- Click handler ---
document.addEventListener("click", function (e) {
    const btn = e.target.closest(".aldo-plp-swatches__btn");
    if (!btn) return;

    const swatchWrapper = btn.closest("[data-aldo-plp-swatches]");
    if (!swatchWrapper) return;

    swatchWrapper
        .querySelectorAll(".aldo-plp-swatches__btn.is-selected")
        .forEach(el => el.classList.remove("is-selected"));

    btn.classList.add("is-selected");

    updateSwatchImage(swatchWrapper, btn);
});

// --- On page load ---
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-aldo-plp-swatches]").forEach(swatchWrapper => {
        const selectedBtn = swatchWrapper.querySelector(".aldo-plp-swatches__btn.is-selected");
        if (!selectedBtn) return;

        updateSwatchImage(swatchWrapper, selectedBtn);
    });
});




// Menu Drawer functionality

    document.querySelectorAll('.menu-tap-drawer, .menu-sidebar-cta-main').forEach((menuItem) => {
        menuItem.addEventListener('click', function () {

            // remove active from all menu items
            document.querySelectorAll('.menu-tap-drawer').forEach((item) => {
            item.classList.remove('active');
            });

            // remove active from all mega menu containers
            document.querySelectorAll('.menu-sidebar-container').forEach((menu) => {
            menu.classList.remove('active');
            });

            // remove active from common containers
            document.querySelector('.menu-sidebar')?.classList.remove('active');
            document.querySelector('.section-header')?.classList.remove('active');

            // active current menu item
            this.classList.add('active');

            // get target value
            const menuTarget = this.getAttribute('aria-label');

            // find matching mega menu
            const activeMenu = document.querySelector(
            `.menu-sidebar-container[aria-expanded="${menuTarget}"]`
            );

            // add active to matching menu
            if (activeMenu) {
            activeMenu.classList.add('active');

            // add active to common parent containers
            document.querySelector('.menu-sidebar')?.classList.add('active');
            document.querySelector('.section-header')?.classList.add('active');
            }
        });
    });
    document.querySelectorAll('.cta-close-drawer, .drawer-overlay-menu').forEach((button) => {
        button.addEventListener('click', function () {
            document.querySelector('.menu-sidebar').classList.remove('active');
            document.querySelectorAll('.menu-sidebar-container').forEach((item) => {
                item.classList.remove('active');
            });
            document.querySelectorAll('.menu-sidebar .active').forEach((item) => {
                item.classList.remove('active');
            });
            document.querySelector('.menu-sidebar')?.classList.remove('active');
            document.querySelector('.section-header')?.classList.remove('active');
        });
    });
    
    document.querySelectorAll('.cta-back-drawer').forEach((button) => {
        button.addEventListener('click', function () {
            const parentContainer = this.closest('.menu-sidebar-container');

            if (parentContainer) {
            parentContainer.classList.remove('active');
            }
        });
    });
    document.querySelectorAll('.hasmenu').forEach((menu) => {
        menu.addEventListener('click', function (e) {
            e.preventDefault();

            this.classList.toggle('active');

            const nextUl = this.nextElementSibling;

            if (nextUl && nextUl.tagName === 'UL') {
            nextUl.classList.toggle('active');
            }
        });
    });
    document.querySelectorAll('.cta-back-drawer').forEach((button) => {
        button.addEventListener('click', function () {

            const container = this
            .closest('.menu-sidebarinner')
            .querySelector('.menu-sidebar-cta-main-container-inner');

            if (container) {
            container.querySelectorAll('.active').forEach((item) => {
                item.classList.remove('active');
            });
            }

        });
    });
    document.querySelectorAll('.open-main-menu').forEach((button) => {
        button.addEventListener('click', function () {
            document.querySelector('.menu-sidebar').classList.add('active');
        });
    });




    const overlayclose = document.querySelector(".filters-open .overlay-wrapper");
    
    if (overlayclose) {
        overlayclose.onclick = function () {
          const closeFilter = document.querySelector(".close-filter");
console.log('dfgdf')
            if (closeFilter) {
              closeFilter.click();
            }
            document.body.classList.remove("sizechart-active");
            
            document.querySelector(".close-filter")?.click();
            document.querySelector(".aa-ClearButton")?.click();
        };
    }




    document.addEventListener("DOMContentLoaded", function () {

    const atcButton = document.querySelector(".product-form__submit");

    if (!atcButton) return;

    const observer = new IntersectionObserver(
        ([entry]) => {

            if (entry.isIntersecting) {
                // Add to Cart button is visible
                document.body.classList.remove("sticky-atcbtn");
            } else {
                // Add to Cart button is out of view
                document.body.classList.add("sticky-atcbtn");
            }

        },
        {
            threshold: 0
        }
    );

    observer.observe(atcButton);

});

document.addEventListener("click", function (event) {

    if (event.target.closest(".product-form__submit-sticky")) {

        const originalButton = document.querySelector(".product-form__submit");

        if (originalButton) {
            originalButton.click();
        }

    }

});

